import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=21982633&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"
import style0 from "./agent.vue?vue&type=style&index=0&id=21982633&prod&scoped=true&lang=css"
import style1 from "./agent.vue?vue&type=style&index=1&id=21982633&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21982633",
  null
  
)

export default component.exports